// extracted by mini-css-extract-plugin
export default {"welcomeCard":"WelcomePage_welcomeCard__95byj","capabilitiesList":"WelcomePage_capabilitiesList__09FtP","ctaBox":"WelcomePage_ctaBox__lAtdH"};